import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { BudgetFilterOptions } from '../types/budget';

interface UseBudgetFiltersResult {
  filterOptions: BudgetFilterOptions | null;
  latestFiscalYear: string | null;
  isLoading: boolean;
  error: unknown;
}

export const useBudgetFilters = (): UseBudgetFiltersResult => {
  const { data, isLoading, error } = useQuery<{ success: boolean; data: BudgetFilterOptions }>({
    queryKey: ['budget-filter-options'],
    queryFn: async () => {
      const response = await api.get('/budget/filters/options');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  const filterOptions = data?.data || null;
  const latestFiscalYear = useMemo(
    () => filterOptions?.fiscalYears?.[0] ?? null,
    [filterOptions]
  );

  return {
    filterOptions,
    latestFiscalYear,
    isLoading,
    error,
  };
};
